import React from 'react'
import { Modal } from 'react-bootstrap'

export default class formInput extends React.Component {

    render() {
        const { changeHandler, saveHandler, Model, ShowModal, cancelHandler, errors, Mode } = this.props

        return (

            // <div id="hapus_relasi" class="modal fade delete-modal" role="dialog">
            //     <div class="modal-dialog modal-dialog-centered">
            //         <div class="modal-content">
            //             <div class="modal-body text-center">
            //                 <img src="assets/img/sent.png" alt="" width="50" height="46" />
            //                 <h3>{Mode}</h3>
            //                 <div class="m-t-20"> <a href="#" class="btn btn-white" data-dismiss="modal">Close</a>
            //                     <button type="submit" class="btn btn-danger">Delete</button>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // </div>

            <div class="mb-10">

                <Modal show={ShowModal} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                    <div class="mb-3">
                            <label for="name" class="form-label">Nama *</label>
                            <input type="name" class="form-control" id="name" value={Model.name} onChange={changeHandler("name")}></input>
                            <span className="error">{errors["name"]}</span>
                        </div>

                        <div class="mb-3">
                            <label for="abbreviation" class="form-label">Nama Singkat</label>
                            <input type="abbreviation" class="form-control" id="abbreviation" value={Model.abbreviation} onChange={changeHandler("abbreviation")}></input>
                            <span className="error">{errors["abbreviation"]}</span>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Submit</button>
                        <button type="button" class="btn btn-primary" onClick={cancelHandler}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
